import { Controller, useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';

import { FormFieldWrapper } from 'components/shared/BaseFormComponents';
import { InputDatePicker, InputDayPicker } from 'components/shared/HookFormComponents/datePicker/inputs';
import { EOrganizedBy, ETripEvent, ITripEvent } from 'detailsv2/structure';
import { itineraryScheduleTypeSelector } from 'store/itinerariesItem/selectors';

export const DayOrDatePicker = () => {
  const { control } = useFormContext();
  const scheduleType = useSelector(itineraryScheduleTypeSelector);
  const isOrganizeByDate = scheduleType === EOrganizedBy.Date;

  if (isOrganizeByDate) {
    return (
      <Controller<Partial<ITripEvent<ETripEvent.Accommodation>>, 'datesRange'>
        name="datesRange"
        control={control}
        render={(fieldProps) => (
          <FormFieldWrapper errorMessage={fieldProps.fieldState.error?.message}>
            <InputDatePicker placeholder="Dates of Stay" mode="range" {...fieldProps}>
              <InputDatePicker.NightsCountPlank mode="range" {...fieldProps} />
            </InputDatePicker>
          </FormFieldWrapper>
        )}
      />
    );
  }

  return (
    <Controller<Partial<ITripEvent<ETripEvent.Accommodation>>, 'daysRange'>
      name="daysRange"
      control={control}
      render={(fieldProps) => (
        <FormFieldWrapper errorMessage={fieldProps.fieldState.error?.message}>
          <InputDayPicker placeholder="Days of Stay" mode="range" {...fieldProps}>
            <InputDayPicker.NightsCountPlank mode="range" {...fieldProps} />
          </InputDayPicker>
        </FormFieldWrapper>
      )}
    />
  );
};
